import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

const styles = (theme) => ({
    baseStyle: {
        fontFamily: "MAN-light, Arial, sans-serif",
        fontSize: theme.typography.pxToRem(15),
        fontWeight: "normal",
        color: "#303c49",
        lineHeight: 1.6,
    },
    linkStyle: {
        fontWeight: "bold",
        color: "#838a92",
        display: "inline-flex",
    },
});

const ListText = ({ classes: { baseStyle, linkStyle }, className, component, isLink, children, ...otherProps }) => {
    const textClass = classNames(baseStyle, isLink ? linkStyle : "", className);
    return (
        <Typography component={component || "span"} className={textClass} {...otherProps}>
            {children}
        </Typography>
    );
};

ListText.propTypes = {
    classes: PropTypes.object.isRequired,
    className: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]),
    component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    isLink: PropTypes.bool,
    children: PropTypes.node,
};

export default withStyles(styles)(ListText);



// WEBPACK FOOTER //
// ./src/styleguide/ListText.js